import { FormErrors } from 'redux-form';

import { TeamMemberEditFormValues } from '../../team.types';
import { validateSecurityGroups } from '../team-member-form/team-member-form.validation';
import { IntlShape } from 'react-intl';

export const validateTeamMemberEditForm = (
  values: TeamMemberEditFormValues,
  intl: IntlShape,
): FormErrors<TeamMemberEditFormValues, any> => ({
  securityGroups: validateSecurityGroups(values.securityGroups, intl),
});
